import React from 'react'
import cx from "classnames";
import CheckSpotsList from '../../components/CheckSpotsList/CheckSpotsList';
import { Input } from 'reactstrap';
import DropDown from '../DropDown/DropDown';
import { getButtonText, getSelected, handleFieldChange } from '../../services/filters';
import { formSpotNamesConvertor } from '../../services/formNamesConvertor';
import { ModalConsumer } from '../../common/ModalContext';
import Button from '../../components/Button/Button';
import { getOptionsLocalized } from '../../services/optionsLocalized';
import { CATEGORY_BUSINESS } from '../../constants/business';
import { getSearchOptions } from '../../services/getSearchOptions';
import ModalWithDropDown from '../../components/ModalWithDropDown/ModalWithDropDown';
import styles from './SpotForm.module.scss'

const FirstStep = ({ state }) => {

  const {
    name, setName,
    category, setCategory,
    businessFields, setBusinessFields,
    organizationFields, setOrganizationFields,
    description, setDescription,
    validationError, setValidationError,
    spotsByName, setSpotsByName,
    getItemToEdit,
    setSpotType,
    spotToEdit,
    checkSpot,
    changeValidationError,
    cancelValidationError,
    type,
    website,
    setWebsite,
    spotURLExist,
    spotsByUrl,
    setSpotsByUrl
  } = state

  const getType = () => {
    switch (type) {
      case 'business':
        return 'businessFields'
      case 'NGO':
        return 'organizationFields'
      default:
        return;
    }
  }
  const getTypeText = () => {
    switch (type) {
      case 'business':
        return 'Business fields'
      case 'NGO':
        return 'Organization fields'
      default:
        return;
    }
  }
  const getTypeState = (type) => {
    switch (type) {
      case 'businessFields':
        return businessFields
      case 'organizationFields':
        return organizationFields
      default:
        return;
    }
  }
  const getChangeFilterFunction = (modalId, value) => {
    ///MOVE TO SERVICES
    // eslint-disable-next-line default-case
    switch (modalId) {
      case "organizationFields":
        setOrganizationFields(value);
        break;
      case "businessFields":
        setBusinessFields(value);
        break;
      case "category":
        setCategory(value);
        break;
    }
  };
  return (
    <div className={cx(styles.stepsContainer)}>
      {spotToEdit.noChanges && <span className={styles.noChanges}>It is forbidden to do changes to this organization. Contact your manager if you have to make changes to this company.Заборонено вносити зміни в цю організацію. Зверніться до свого менеджера, якщо вам необхідно внести зміни в цю компанію </span>}
      <p className={styles.title}>General</p>
      <div className={cx(styles.inlineFormLogo)}>
        <div className={styles.formItem}>
          <p className={styles.fieldLabel}>name company*</p>
          <Input
            name="name"
            placeholder="Name company"
            value={name}
            onChange={(event) => {
              setName(event.target.value);
              setValidationError(
                validationError.filter((errorItem) => errorItem !== "name")
              )
            }}
            className={cx(styles.input, {
              [styles.inputError]: validationError.includes("name"),
            })}
            onBlur={() => checkSpot("name", name, setSpotsByName)}
          />
          {!spotToEdit && (
            <CheckSpotsList spots={spotsByName} getItemToEdit={getItemToEdit}
            //  getActiveSpotType={setSpotType} 
            />
          )}
        </div>
      </div>
      {
        (type === 'business' || type === 'NGO') &&
        <div className={styles.inlineForm}>
          {
            type === 'business' &&
            <div className={styles.formItem}>
              <div className={cx(styles.dropDownDesktop, styles.marginTopNone)}>
                <p className={styles.fieldLabel}>Business Category*</p>
                <DropDown
                  name="category"
                  className={styles.autocomplete}
                  changeValidationError={changeValidationError}
                  onChange={handleFieldChange.bind({
                    filter: "category",
                    changeFilter: setCategory,
                    selected: category,
                    cancelValidationError: cancelValidationError,
                  })}
                  selected={category}
                  onClear={() => setCategory([])}
                  dropDownErrorClass={
                    validationError.includes("category") && styles.dropDownError
                  }
                  options={CATEGORY_BUSINESS}
                  buttonText={getButtonText(
                    category,
                    formSpotNamesConvertor("category"),
                    "category"
                  )}
                />
              </div>
            </div>
          }
          <div className={cx(styles.formItem, {
            [styles.inlineSpace]: type === 'business'
          })}>
            <div className={cx(styles.dropDownDesktop, styles.marginTopNone)}>
              <p className={styles.fieldLabel}>Fields*</p>
              <DropDown
                name={getType()}
                className={styles.autocomplete}
                changeValidationError={changeValidationError}
                onChange={handleFieldChange.bind({
                  filter: getType(),
                  changeFilter: type === 'NGO' ? setOrganizationFields : setBusinessFields,
                  selected: getTypeState(getType()),
                  cancelValidationError: cancelValidationError,
                })}
                selected={getTypeState(getType())}
                onClear={() => type === 'NGO' ? setOrganizationFields([]) : setBusinessFields([])}
                dropDownErrorClass={
                  validationError.includes(getType()) &&
                  styles.dropDownError
                }
                options={getOptionsLocalized(getType())?.filter((option) => option.value !== "all")}
                buttonText={getButtonText(
                  getTypeState(getType()),
                  formSpotNamesConvertor(getType()),
                  getType()
                )}
              />

            </div>
            {
              type === 'business' &&
              <div className={cx(styles.dropDownMobile, styles.marginTopNone)}>
                <ModalConsumer>
                  {({ toggleModal }) => (
                    <>
                      <p
                        className={cx(styles.fieldLabel, {
                          [styles.labelError]: validationError.includes("category"),
                        })}
                      >
                        Business category*
                      </p>
                      <Button
                        onClick={() => {
                          toggleModal("category");
                        }}
                        className={cx(
                          styles.filterButton,
                          {
                            [styles.dropDownError]:
                              validationError.includes("category"),
                          },
                          category.length ? styles.labelValue : styles.labelName
                        )}
                      >
                        {getButtonText(category, "Category", "category")}
                      </Button>
                    </>
                  )}
                </ModalConsumer>
              </div>
            }
            <div className={cx(styles.dropDownMobile, { [styles.marginTopNone]: type !== 'business' })}>
              <ModalConsumer>
                {({ toggleModal }) => (
                  <>
                    <p
                      className={cx(styles.fieldLabel, {
                        [styles.labelError]:
                          validationError.includes(getType()),
                      })}
                    >
                      Fields*
                    </p>
                    <Button
                      onClick={() => {
                        toggleModal(getType());
                      }}
                      className={cx(
                        styles.filterButton,
                        {
                          [styles.dropDownError]:
                            validationError.includes(getType()),
                        },
                        getTypeState(getType()).length
                          ? styles.labelValue
                          : styles.labelName
                      )}
                    >
                      {getButtonText(
                        getTypeState(getType()),
                        getTypeText(getType),
                        getType()
                      )}
                    </Button>
                  </>
                )}
              </ModalConsumer>
            </div>
          </div>
        </div>
      }


      <div className={cx(styles.formItem)}>
        <p className={styles.fieldLabel}>website*</p>
        <Input
          name="website"
          placeholder="https://www.company.com"
          value={website}
          onChange={(event) => {
            setWebsite(event.target.value);
            setValidationError(
              validationError.filter((errorItem) => errorItem !== "website")
            )
          }}
          className={cx(styles.input, {
            [styles.inputError]: validationError.includes("website"),
          })}
          onBlur={() => checkSpot("url", website, setSpotsByUrl)}
        />
        <p
          className={cx(styles.errorLabel, {
            "d-block": spotURLExist,
          })}
        >
          This URL already registered in ecohubmap
        </p>
        {!spotToEdit && (
          <CheckSpotsList spots={spotsByUrl} getItemToEdit={getItemToEdit} getActiveSpotType={setSpotType} />
        )}
      </div>


      <div className={styles.textareaContainer}>
        <p className={styles.fieldLabel}>description</p>
        <Input
          className={cx(styles.textarea, {
            [styles.inputError]: validationError.includes("description"),
          })}
          type="textarea"
          name="text"
          placeholder="Description"
          onChange={(event) => {
            setDescription(event.target.value);
            setValidationError(
              validationError.filter(
                (errorItem) => errorItem !== "description"
              )
            );
          }}
          value={description}
        />
      </div>
      <ModalConsumer>
        {({ isOpen, toggleModal, modalId }) => {
          return (
            ( // TO REFACTOR ONE OF
              modalId === "organizationFields" ||
              modalId === "businessFields" ||
              modalId === "category") && (
              <ModalWithDropDown
                onSave={toggleModal}
                toggleModal={toggleModal}
                isOpen={isOpen}
                name={modalId}
                options={getSearchOptions(modalId).filter(
                  (option) => option.value !== "all"
                )}
                selected={getSelected({
                  modalId,
                  organizationFields,
                  businessFields,
                  category,
                })}
                onChange={handleFieldChange.bind({
                  filter: modalId,
                  changeFilter: (value) =>
                    getChangeFilterFunction(modalId, value),
                  selected: getSelected({
                    modalId,
                    organizationFields,
                    businessFields,
                    category,
                  }),
                  cancelValidationError: cancelValidationError,
                })}
                onClear={() => getChangeFilterFunction(modalId, [])}
                changeValidationError={changeValidationError}
              />
            )
          );
        }}
      </ModalConsumer>
    </div>
  )
}

export default FirstStep